import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "pagination mt-30 mt-xs-10"
}
const _hoisted_2 = ["disabled"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-chevron-left" }, null, -1 /* HOISTED */)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-chevron-right" }, null, -1 /* HOISTED */)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 0,
  class: "spinner-grow align-self-center ms-3",
  role: "status"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...", -1 /* HOISTED */)
const _hoisted_10 = [
  _hoisted_9
]

import { h, VNode, withDefaults, withModifiers } from 'vue'

interface Props {
  modelValue: number
  totalPages: number
  // Max number of pagination buttons to display, excluding arrows, the remaining is filled with ellipsis ...
  maxButtons?: number
  loading?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Pagination',
  props: {
    modelValue: null,
    totalPages: null,
    maxButtons: { default: 6 },
    loading: { type: Boolean, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'update:modelValue', currentPage: number): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { modelValue: number, totalPages: number, maxButtons: number, loading: boolean };




function updatePage(newPage: number) {
  if (newPage < 1) {
    newPage = 1
  }
  if (newPage > props.totalPages) {
    newPage = props.totalPages
  }
  emits('update:modelValue', newPage)
}

function PagesButtons(): Array<VNode> {
  const pages: Array<VNode> = []
  let leftEllipsisAdded = false
  let rightEllipsisAdded = false
  for (let i = 1; i <= props.totalPages; i++) {
    // Example render: [1, 2, 3, ..., 11, 12, 13, 14]
    if (
      i === props.modelValue ||
      props.totalPages <= props.maxButtons ||
      (props.totalPages > props.maxButtons &&
        (i <= props.maxButtons / 2 || i >= props.totalPages - props.maxButtons / 2))
    ) {
      pages.push(
        h(
          'a',
          {
            href: '#',
            class: props.modelValue === i ? 'active' : undefined,
            style: props.modelValue === i ? 'border: 2px solid #555' : undefined,
            onClick: withModifiers(() => {
              updatePage(i)
            }, ['prevent']),
          },
          i
        )
      )
    } else if (i < props.modelValue && !leftEllipsisAdded) {
      pages.push(h('a', { class: 'no-active' }, '...'))
      leftEllipsisAdded = true
    } else if (i > props.modelValue && !rightEllipsisAdded) {
      pages.push(h('a', { class: 'no-active' }, '...'))
      rightEllipsisAdded = true
    }
  }
  return pages
}

return (_ctx: any,_cache: any) => {
  return (__props.totalPages > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("a", {
          href: "#",
          class: _normalizeClass({ 'no-active': props.modelValue === 1 }),
          disabled: props.modelValue === 1,
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (updatePage(props.modelValue - 1)), ["prevent"]))
        }, _hoisted_4, 10 /* CLASS, PROPS */, _hoisted_2),
        _createVNode(PagesButtons),
        _createElementVNode("a", {
          href: "#",
          class: _normalizeClass({ 'no-active': props.modelValue === props.totalPages }),
          disabled: props.modelValue === props.totalPages,
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (updatePage(props.modelValue + 1)), ["prevent"]))
        }, _hoisted_7, 10 /* CLASS, PROPS */, _hoisted_5),
        (__props.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
          : _createCommentVNode("v-if", true)
      ]))
    : _createCommentVNode("v-if", true)
}
}

})